export const partNumber =
  'The part number/name is used to uniquely identify your surface mount carrier. It is usually the same part number/name as your printed circuit board (PCB)';

export const revision =
  'We recommend adding a revision number to each part number';

export const materialThickness =
  '6mm, 8mm or 12mm are the standard thicknesses';

export const stencilFile =
  'Please include Gerber files and bill of material (BOM). If you have 3D file of the PCB, please include as well';

export const carrierWidth = 'Width of the base plate';

export const carrierLength = 'Length of the base plate';

export const printConfirmation =
  'Select “Yes” to request a check plot or proof of the artwork before manufacturing the carrier.';

export const pressureHolderType =
  'Designed to push the board towards a corner of the pocket in order to keep it in place during process. They sit at the same height or lower height than the PCB to allow for SMT printing';
